import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { clientAPI } from "../api/client";
import { NumberOfPerPage } from "../utils/globalVariable";
import { formatNumber } from "../utils/utils";

const NUMBER_NFT_PER_PAGE = NumberOfPerPage.apartment;
const queryKey = "apartment";

async function fetchApartment(
  currentPage,
  search,
  projectId,
  totalValue,
  priceForCommission,
  estimatedServiceFeePrice,
  saleOpeningEvent,
  statusApartMent,
  apartmentTypeId,
  getRoleUser
) {
  try {
    const options = {
      limit: NUMBER_NFT_PER_PAGE,
      page: currentPage,
    };

    if (search !== undefined) options.search = search;
    if (projectId) options.projectId = projectId;
    if (totalValue) options.totalValue = totalValue;
    if (priceForCommission) options.priceForCommission = priceForCommission;
    if (estimatedServiceFeePrice)
      options.estimatedServiceFeePrice = estimatedServiceFeePrice;
    if (saleOpeningEvent?.length > 0)
      options.saleOpeningEventId = saleOpeningEvent;
    if (apartmentTypeId) options.apartmentTypeId = apartmentTypeId;
    if (statusApartMent) options.statusApartMent = statusApartMent;

    const queryParams = new URLSearchParams(options).toString();
    let data = await clientAPI("get", `/apartment?${queryParams}`);
    const totalPages = Math.ceil(data?.pagination?.total / NUMBER_NFT_PER_PAGE);
    const entries = data?.pagination?.total;
    const startEntry =
      (data?.pagination?.page - 1) * data?.pagination?.limit + 1;
    const endEntry = Math.min(
      data?.pagination?.page * data?.pagination?.limit,
      entries
    );

    const newData = data?.items.map((item, index) => {
      return {
        id: item?._id || "",
        isCanDelete: item?.isCanDelete || false,
        code: item?.code || "-",
        name: item?.name || "-",
        // area: item?.area ? `${item?.area} m2` : "-",
        // areaOfWater: item?.areaOfWater ? `${formatNumber(item?.areaOfWater)} m2` : "-",
        // builtUpArea: item?.builtUpArea ? `${formatNumber(item?.builtUpArea)} m2` : "-",
        // grossFloorArea: item?.grossFloorArea ? `${formatNumber(item?.grossFloorArea)} m2` : "-",
        // width: item?.width ? `${formatNumber(item?.width)} m` : "-",
        // length: item?.length ? `${formatNumber(item?.length)} m` : "-",
        // numberOfBedrooms: item?.numberOfBedrooms || "-",
        // numberOfToilets: item?.numberOfToilets || "-",
        // direction: item?.direction?.name || "-",
        // apartmentType: item?.apartmentType?.name || "-",
        // property: item?.property?.name || "-",
        project: item?.project?.name || "-",
        // kRate: item?.kRate || "0",
        hotBonusPercent: item?.hotBonusPercent || "0",
        // division: item?.division?.name || "-",
        totalValue: item?.totalValue
          ? `${formatNumber(item?.totalValue)} VNĐ`
          : "0 VNĐ",
        priceForCommission: item?.priceForCommission
          ? `${formatNumber(item?.priceForCommission)} VNĐ`
          : "0 VNĐ",
        estimatedServiceFeePrice: item?.estimatedServiceFeePrice
          ? `${formatNumber(item?.estimatedServiceFeePrice)} VNĐ`
          : "0 VNĐ",
        saleOpeningEvents:
          Array.isArray(item?.saleOpeningEvents) &&
          item.saleOpeningEvents.length
            ? item.saleOpeningEvents.map((e) => e.name).join(", ")
            : "-",
        edit: {
          id: item?._id || "",
          code: item?.code || "",
          name: item?.name || "",
          area: item?.area || 0,
          builtUpArea: item?.builtUpArea || 0,
          width: item?.width || 0,
          length: item?.length || 0,
          numberOfBedrooms: item?.numberOfBedrooms || 0,
          numberOfToilets: item?.numberOfToilets || 0,
          directionId: item?.directionId || "",
          apartmentTypeId: item?.apartmentTypeId || "",
          propertyId: item?.propertyId || "",
          projectId: item?.projectId || "",
          saleOpeningEventId : item?.apartmentSaleOpeningEventLink?.saleOpeningEventId || "",
          divisionId: item?.divisionId || "",
          totalValue: item?.totalValue || 0,
          priceForCommission: item?.priceForCommission || 0,
          estimatedServiceFeePrice: item?.estimatedServiceFeePrice || 0,
          areaOfWater: item?.areaOfWater || 0,
          grossFloorArea: item?.grossFloorArea || 0,
          // kRate: item?.kRate || 0,
          hotBonusPercent: item?.hotBonusPercent || 0,
          rateTNSan: item?.rateTNSan || 0,
          transactionRate: item?.transactionRate || 0,
          priceTNSan: item?.priceTNSan || 0,
        },
        detail: {
          id: item?._id || "",
          code: item?.code || "-",
          name: item?.name || "-",
          area: item?.area || "",
          areaOfWater: item?.areaOfWater || "",
          builtUpArea: item?.builtUpArea || "",
          grossFloorArea: item?.grossFloorArea || "",
          width: item?.width || "",
          length: item?.length || "",
          numberOfBedrooms: item?.numberOfBedrooms || "-",
          numberOfToilets: item?.numberOfToilets || "-",
          direction: item?.direction,
          apartmentType: item?.apartmentType,
          property: item?.property,
          project: item?.project,
          // kRate: item?.kRate || "",
          hotBonusPercent: item?.hotBonusPercent || "",
          division: item?.division,
          totalValue: item?.totalValue || "",
          priceForCommission: item?.priceForCommission || "",
          estimatedServiceFeePrice: item?.estimatedServiceFeePrice || "",
          saleOpeningEvents:
            Array.isArray(item?.saleOpeningEvents) &&
            item.saleOpeningEvents.length
              ? item.saleOpeningEvents.map((e) => e.name).join(", ")
              : "-",
              
          rateTNSan: item?.rateTNSan || "",
          transactionRate: item?.transactionRate || "",
          priceTNSan: item?.priceTNSan || "",
        },
      };
    });

    return { data: newData, totalPages, entries, startEntry, endEntry };
  } catch (error) {
    console.error("Error fetching checkIn data:", error);
    return { data: [], totalPages: 0 };
  }
}

export function useApartmentManager(
  search,
  projectId,
  totalValue,
  priceForCommission,
  estimatedServiceFeePrice,
  saleOpeningEvent,
  statusApartMent,
  apartmentTypeId,
  getRoleUser
) {
  const [currentPage, setCurrentPage] = useState(1);

  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: [
      queryKey,
      currentPage,
      search,
      projectId,
      totalValue,
      priceForCommission,
      estimatedServiceFeePrice,
      saleOpeningEvent,
      statusApartMent,
      apartmentTypeId,
      getRoleUser,
    ],
    queryFn: () =>
      fetchApartment(
        currentPage,
        search,
        projectId,
        totalValue,
        priceForCommission,
        estimatedServiceFeePrice,
        saleOpeningEvent,
        statusApartMent,
        apartmentTypeId,
        getRoleUser
      ),
    refetchOnWindowFocus: false,
    staleTime: 30000,
    keepPreviousData: true,
    onError: (error) => {
      console.error("Error fetching checkIn data:", error);
    },
  });

  const nextPage = () => {
    if (currentPage < data?.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return {
    apartmentData: data?.data,
    totalPages: data?.totalPages,
    refetch,
    isLoading,
    isRefetching,
    prevPage,
    nextPage,
    setCurrentPage,
    currentPage,
    entries: data?.entries,
    startEntry: data?.startEntry,
    endEntry: data?.endEntry,
  };
}
